import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { EventManager, UserService } from 'src/app/core';
import { EditComponent } from '../edit.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { AppQueries } from 'src/app/state';
import { FormBuilder } from '@angular/forms';
import { DateUtil } from '../../util/date.util';
import { NotificationService } from 'src/app/modules/users/users.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-edit-schedule-notification',
  templateUrl: './edit-schedule-notification.component.html',
  styleUrls: ['./edit-schedule-notification.component.scss']
})
export class EditScheduleNotificationComponent extends EditComponent implements OnInit {
  @Input() filterReceiver: any;
  subscriptions?: Subscription[] = [];
  isSaved: boolean = false;
  isCall: boolean = false;
  slider: any;
  @Output() result: EventEmitter<any> = new EventEmitter();
  errors: any = {};
  kycStatus = [ {code: 'NOT_ACTIVE', name: 'Chưa kích hoạt' }, {code: 'NOT_FULL_INFO', name: 'Chưa đủ thông tin'}, 
  {code: 'NOT_KYC', name: 'Chưa KYC'}, {code: 'KYC', name: 'Đã KYC'}];
  statusList: any[] = [];
  editForm = this.fb.group({
    schedulerDay: [''],
    scheduledTime: [''],
  });
  scheduledTime: any;
  constructor(
    private fb: FormBuilder,
    public eventManager: EventManager,
    private sessionStorageService: SessionStorageService,
    public route: ActivatedRoute,
    public router: Router,
    private notificationService: NotificationService,
    private toastService: ToastrService,
    private appQueries: AppQueries,
  ) {
    super(eventManager, route)
  }
  ngOnInit() {
    this.subscriptions = [
      this.appQueries.crmStatuses$
      .subscribe((crmStatuses) => {
        this.statusList = crmStatuses;
      }),
    ];
    const params = this.route.snapshot.queryParams;
    this.detailObject = this.sessionStorageService.retrieve('notification') || {};
    this.scheduledTime = this.sessionStorageService.retrieve('scheduledTime') || {};
    this.detailObject.scheduleId = params.scheduleId;
    this.filterReceiver = this.detailObject.filterReceiver || {};
    this.detailObject.issuers = (this.filterReceiver.issuerIds || []).map(item => item.name).join(', ');
    this.detailObject.products = (this.filterReceiver.productIds || []).map(item => item.name).join(', ');
    this.detailObject.provinces = (this.filterReceiver.provinceIds || []).map(item => item.name).join(', ');
    this.detailObject.receivers = (this.filterReceiver.receivers || []).join(', ');
    this.detailObject.kycStatusCode = (this.kycStatus.find(item => item.code === this.filterReceiver.kycStatusCode) || {code: '', name: ''}).name;
    this.detailObject.crmStatus = '';
    (this.filterReceiver.crmStatusCodes || []).forEach((id) => {
      const find = this.statusList.find(item => item.id == id) || {};
      this.detailObject.crmStatus += (find.name || '') + ', ';
    });
    this.updateForm();
  }
  disabledButton() {
    this.isSaved = true;
    if (this.editForm.value.schedulerDay && !this.editForm.value.scheduledTime) {
      this.errors.scheduledTime = true;
    } else {
      this.errors.scheduledTime = false;
    }
    if (!this.editForm.value.schedulerDay && this.editForm.value.scheduledTime) {
      this.errors.schedulerDay = true;
    } else {
      this.errors.schedulerDay = false;
    }
    const scheduledTime = this.editForm.value.schedulerDay && this.editForm.value.scheduledTime ? 
    DateUtil.revertDate(`${this.editForm.value.schedulerDay} ${this.editForm.value.scheduledTime}`, 'yyyy-MM-dd hh:mm').getTime() : undefined;
    if (scheduledTime && scheduledTime < Date.now()) {
      this.errors.schedulerOver = true;
    } else {
      this.errors.schedulerOver = false;
    }
    const keys = Object.keys(this.errors);
    const key = keys.find(key => this.errors[key]);
    return key ? true : false;
  }
  updateForm() {
    this.scheduledTime = !this.scheduledTime ? undefined : new Date(this.scheduledTime).getTime();
  }
  patchValue(key, value) {
    this.editForm.patchValue({[key]: value});
  }
  save() {
    this.isSaved = true;
    if (this.disabledButton() || this.editForm.invalid || !this.scheduledTime) {
      return;
    }
    this.isCall = true;
    const body = {
      broadcastSchedulerId: this.detailObject.scheduleId,
      scheduledTime: this.scheduledTime
    }
    this.notificationService.updateScheduleNotification(body)
    .subscribe(() => {
      this.toastService.success('Push Notification thành công!');
      this.router.navigate(['users/schedule-notification']);
    })
  }
}
